import { render, staticRenderFns } from "./moreservices.vue?vue&type=template&id=26e153c2&"
import script from "./moreservices.vue?vue&type=script&lang=js&"
export * from "./moreservices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbyimage: require('/opt/build/repo/components/kirbyimage.vue').default})
